import React, { useState, useEffect } from "react";
import { createClient } from "@supabase/supabase-js";
import { motion, AnimatePresence } from "framer-motion";
import './Layout.css';

const API_URL = "/.netlify/functions/getVisitCount";

const SiteCounter = () => {
  const [dreamers, setDreamers] = useState(null);
  const [isVisible, setIsVisible] = useState(false);
  const [animatedCount, setAnimatedCount] = useState(0);

  useEffect(() => {
    const storedCount = sessionStorage.getItem("dreamersCount");

    if (storedCount) {

      const count = parseInt(storedCount, 10);
      setDreamers(count);
      animateCount(count);
      setIsVisible(true);

    } else {
        
      fetchDreamersCount();

    }
  }, []);

  const fetchDreamersCount = async () => {
    
    try {
      const response = await fetch(API_URL);
      const result = await response.json();

      if (response.ok && result.count !== null) {
        sessionStorage.setItem("dreamersCount", result.count);
        setDreamers(result.count);
        setIsVisible(true);
        animateCount(result.count);
      } else {
        console.error("Error fetching unique views:", result.error);
      }
    } catch (error) {
      console.error("Error fetching dreamers count:", error);
    }
  };

  const animateCount = (target) => {
    let start = Math.max(0, target - 450);
    let current = start;
    let interval = 6; // Initial speed (lower = faster updates)
  
    const updateCounter = () => {
      let remaining = target - current;
  
      // Adjust increment based on remaining gap
      let increment = remaining > 20 ? 13 : remaining > 10 ? 1 : 1;
  
      if (current < target) {
        current += increment;
        if (current > target) current = target; // Prevent overshooting
        setAnimatedCount(current);
  
        // Adjust interval (slower as it nears target)
        interval = Math.min(150, interval * 1.1); 
  
        setTimeout(updateCounter, interval);
      }
    };
  
    updateCounter();
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          key="site-counter"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <h5>{animatedCount} Dreamers</h5>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default SiteCounter;
